import styled from '@emotion/styled';

import { forMobile } from '@/design-system';

import { pipelineColors } from './constants';

export const PipelinePageShell = styled('main')(({ theme }) => ({
  height: '100%',
  minHeight: 640,
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  padding: '16px 24px',
  boxSizing: 'border-box',
  background: theme.colors.background.canvas,

  [forMobile]: {
    height: 'auto',
    minHeight: 0,
    padding: '0 16px 16px',
    gap: 16,
  },
}));

export const PipelinePageHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 16,
  minHeight: 36,

  h2: {
    lineHeight: '36px',
  },

  [forMobile]: {
    display: 'none',
  },
});
export const PipelineBoardStack = styled('div')({
  flex: 1,
  height: '100%',
  minHeight: 640,
  display: 'flex',
  flexDirection: 'column',
  gap: 24,

  [forMobile]: {
    height: 'auto',
    minHeight: 0,
    gap: 16,
  },
});

export const PipelineBoardRegion = styled('section')({
  flex: 1,
  minHeight: 0,
});

export const PipelineBadge = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 21,
  boxSizing: 'border-box',
  padding: '2px 8px',
  borderRadius: 8,
  background: pipelineColors.badgeDark,
  color: theme.colors.white[100],
  fontSize: 12,
  lineHeight: '16.8px',
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 400,
  letterSpacing: 0,

  '&[data-variant="outline"]': {
    background: 'transparent',
    border: `1px solid ${theme.colors.white[20]}`,
  },

  '&[data-variant="filled"][data-tone="neutral"]': {
    background: pipelineColors.badgeDark,
    border: `1px solid ${theme.colors.white[20]}`,
  },

  '&[data-tone="blue"]': {
    background: pipelineColors.lightBlue,
    color: theme.colors.black[100],
  },

  '&[data-tone="amber"]': {
    background: pipelineColors.lightYellow,
    color: theme.colors.black[100],
  },

  '&[data-tone="purple"]': {
    background: pipelineColors.purpleSoft,
    color: theme.colors.white[100],
  },

  '&[data-tone="green"]': {
    background: pipelineColors.green,
    color: theme.colors.black[100],
  },

  '&[data-tone="red"]': {
    background: theme.colors.error.solid,
    color: theme.colors.white[100],
  },

  '&[data-variant="muted"]': {
    background: pipelineColors.badgeDark,
    color: theme.colors.white[100],
  },

  '&[data-variant="muted"][data-tone="blue"]': {
    background: pipelineColors.badgeBlueSurface,
    color: pipelineColors.blue,
  },

  '&[data-variant="muted"][data-tone="amber"]': {
    background: pipelineColors.badgeAmberSurface,
    color: pipelineColors.lightYellow,
  },

  '&[data-variant="muted"][data-tone="purple"]': {
    background: pipelineColors.badgePurpleSurface,
    color: pipelineColors.purple,
  },

  '&[data-variant="muted"][data-tone="green"]': {
    background: pipelineColors.badgeGreenSurface,
    color: pipelineColors.green,
  },

  '&[data-variant="muted"][data-tone="red"]': {
    background: pipelineColors.badgeRedSurface,
    color: theme.colors.text.error,
  },

  '&[data-variant="dashed"]': {
    background: pipelineColors.amberColumnSurface,
    border: `1px dashed ${pipelineColors.cardAmberBorder}`,
  },
}));
